import { DegreeType } from '@teachur/http-client';
import type { UserDegree } from '@teachur/http-client';

export const isMasterStudent = (enrolledDegrees: UserDegree[] | undefined): boolean =>
  (enrolledDegrees ?? []).some((ud) => ud.degree?.type === DegreeType.Master);
